import React from "react";
import DashboardChart  from "./components/DashboardChart ";

function App() {
  return (
    <div>
      <DashboardChart />
    </div>
  );
}

export default App;
